import { Record } from 'immutable';
import { SORT_TYPE } from 'records/BaseList';

export const COLUMN_KEY = 'column';
export const DIRECTION_KEY = 'direction';

export const defaultApiValues = {
    [COLUMN_KEY]: null,
    [DIRECTION_KEY]: SORT_TYPE.ASC,
};

// object dto with api
export default Record({ ...defaultApiValues });
